import React from 'react';
import styled from 'styled-components';

const Styles = styled.div`

.title {
    font-weight: 600;
    color:white;
}

.list-unstyled a {
    color:white;
}

.footer-layer {
    background-color:#94795d; 
    margin-top: 2em;
}

.footer-area {
    padding-bottom: 3em;
    font-size: 0.813em;
}

.footer-disclaimer {
    padding-bottom: 1em;
    text-align:center;
}

.footer-disclaimer a {
    color:#a62230;
}
 
.footer-prenav { 
    font-size: 0.713em;
    margin-bottom: 1em;
    padding:2em;
}

.footer-rights {
    text-align:center;
}

.title {
    font-size: 0.713em;
}
`;

const FooterBar = () => {

    return (
        <Styles>
            <div className="footer-layer animate__animated animate__fadeInUp animate__faster">
                <div className="container">
                    <div className="footer-prenav">
                        <div className="row">
                            <div className="col">
                                <h6 className="title">Patients &amp; Visitors</h6>
                                <ul className="list-unstyled">
                                    <li><a href="https://www.ttsh.com.sg/Patients-and-Visitors/Your-Clinic-Visit/Pages/default.aspx" title="Your Clinic Visit"> Your Clinic Visit</a></li>
                                    <li><a href="https://www.ttsh.com.sg/Patients-and-Visitors/Your-Hospital-Stay/Pages/default.aspx" title="Your Hospital Stay"> Your Hospital Stay</a></li>
                                    <li><a href="https://www.ttsh.com.sg/Patients-and-Visitors/Medical-Services/Emergency" title="Emergency"> Your Emergency Visit</a></li>
                                    <li><a href="https://www.ttsh.com.sg/Patients-and-Visitors/Continuing-Care-in-Community-Hospitals/" title="/Patients-and-Visitors/Continuing-Care-in-Community-Hospitals/"> Continuing Care in the Community</a></li>
                                    <li><a href="https://www.ttsh.com.sg/Patients-and-Visitors/Visiting-TTSH/Pages/default.aspx" title="Visiting TTSH"> Visiting TTSH</a></li>
                                    <li><a href="https://www.ttsh.com.sg/Patients-and-Visitors/Wellness/Pages/default.aspx" title="Wellness"> Health &amp; Wellness Programmes</a></li>
                                    <li><a href="https://www.ttsh.com.sg/Patients-and-Visitors/financial-counselling" title="Our FCs seek to provide you peace of mind through our advice on inpatient bill estimates, payment modes &amp; financial assistance"> Financial Counselling</a></li>
                                    <li><a href="https://www.ttsh.com.sg/Patients-and-Visitors/Pages/Find-Specialist.aspx" title="Find a Specialist"> Find a Specialist</a></li>
                                    <li><a href="https://www.ttsh.com.sg/Patients-and-Visitors/Pages/Find-Specialties-and-Services.aspx" title="Find-Specialties-and-Services.aspx"> Find Specialties and Services</a></li>
                                    <li><a href="https://www.ttsh.com.sg/Patients-and-Visitors/TTSH-Health-Library" title="TTSH-Health-Library"> TTSH Health Library</a></li>
                                </ul>
                            </div>
                            <div className="col">
                                <h6 className="title">Healthcare Professionals</h6>
                                <ul className="list-unstyled">
                                    <li><a href="/Healthcare-Professionals/for-undergraduates/Pages/default.aspx" title="Under Graduates"> Pre-Professional Education</a></li>
                                    <li><a href="https://www.nhgeducation.nhg.com.sg/nhgresidency" title="NHG Residency"> NHG Residency</a></li>
                                    <li><a href="/Healthcare-Professionals/medical-education-office/Pages/default.aspx" title="Clinical Fellowship"> Medical Education Office</a></li>
                                    <li><a href="/Healthcare-Professionals/Training-Workshops/Pages/default.aspx" title="Medical Events &amp; Training Courses"> Training &amp; Workshops</a></li>
                                    <li><a href="/Healthcare-Professionals/Research-Innovation/Pages/default.aspx" title="Research &amp; Innovation"> Research &amp; Innovation</a></li>
                                    <li><a href="/Healthcare-Professionals/Nursing-Resources/" title="/Healthcare-Professionals/Nursing-Resources/"> Nursing Resources</a></li>
                                </ul>
                            </div>
                            <div className="col">
                                <h6 className="title">Central Health</h6>
                                <ul className="list-unstyled">
                                    <li><a href="/Community-Health/Pages/default.aspx" title="default.aspx"> Introduction</a></li>
                                    <li><a href="/Community-Health/Find-Care-in-Your-Neighbourhood/Pages/default.aspx" title="Care In Your Neighbourhood"> Find Care in Your Neighbourhood</a></li>
                                    <li><a href="/Community-Health/Central-Health-Newsletter/" title="/Community-Health/Central-Health-Newsletter/"> Central Health Newsletter</a></li>
                                    <li><a href="/Community-Health/Pages/Community-Wellness-Programmes.aspx" title="Community-Wellness-Programmes.aspx"> Community Wellness Programmes</a></li>
                                    <li><a href="/Community-Health/Central-Health-Stories/" title="/Community-Health/Central-Health-Stories/"> Central Health Stories</a></li>
                                    <li><a href="/Healthcare-Professionals/For-General-Practitioners/Pages/default.aspx" title="For General Practitioners (GPs)"> For General Practitioners (GPs)</a></li>
                                    <li><a href="/Community-Health/LTPCCT/Pages/default.aspx" title="default.aspx"> Long Term and Palliative Care Partnerships Team</a></li>
                                </ul>
                            </div>
                            <div className="col">
                                <h6 className="title">About TTSH</h6>
                                <ul className="list-unstyled">
                                    <li><a href="/About-TTSH/Pages/Corporate-Profile.aspx" title="Corporate-Profile.aspx"> Corporate Profile</a></li>
                                    <li><a href="/About-TTSH/Careers/Pages/default.aspx" title="Career"> Careers</a></li>
                                    <li><a href="/About-TTSH/healthcitynovena/" title="/About-TTSH/healthcitynovena/"> HealthCity Novena</a></li>
                                    <li><a href="/About-TTSH/TTSH-News" title="TTSH-News"> News</a></li>
                                    <li><a href="/About-TTSH/TTSH-Events/Pages/default.aspx" title="default.aspx"> Events</a></li>
                                    <li><a href="/About-TTSH/TTSH-Heritage/Pages/default.aspx" title="TTSH Heritage"> Heritage</a></li>
                                    <li><a href="/About-TTSH/TTSH-Community-Fund/Pages/default.aspx" title="TTSH Community Fund"> Donate</a></li>
                                    <li><div className="prefooter-links"><a href="/About-TTSH/Gallery" title="Gallery"> Gallery</a></div></li>
                                    <li><div className="prefooter-links"><a href="/About-TTSH/Volunteer-at-TTSH/Pages/default.aspx" title="Volunteer @ TTSH"> Volunteer</a></div></li>
                                </ul>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
            <div className="container animate__animated animate__fadeInUp animate__faster">
                <div className="footer-area">
                    <div className="footer-disclaimer">
                        <div className="row row-cols-1 row-cols-sm-1 row-cols-md-3">
                            <div className="col">
                                <a href="https://www.ttsh.com.sg/Pages/disclaimer.aspx" title="Disclaimer">Disclaimer</a>
                            </div>
                            <div className="col">
                                <a href="https://www.ttsh.com.sg/Patients-and-Visitors/Your-Hospital-Stay/Pages/Patients-Rights.aspx" title="Personal Data Protection Notification">Personal Data Protection Notification</a>
                            </div>
                            <div className="col">
                                <a href="https://www.ttsh.com.sg/Pages/RateWebsite.aspx" title="Rate this website">Rate this website</a>
                            </div>
                        </div>
                    </div>
                    <div className="footer-rights">
                        <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-6">
                                <p>
                                    © 2021 Tan Tock Seng Hospital. All Rights Reserved.
                        </p>
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-6">
                                <p>
                                    Best Viewed with IE 11, Chrome 69.0, Firefox 61.0, Safari 11
                            </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Styles >
    );
};

export default FooterBar;